import { Box, Stack, Tooltip, Typography } from '@mui/material';
import CopyableText from 'components/atoms/CopyableText';
import { HighlightedText } from 'components/atoms/HighlightedText';
import React from 'react';

interface UploadFileCellProps {
  copyAriaLabel: string;
  copyTooltip: string;
  details?: React.ReactNode;
  displayName: string;
  displayedPath: string;
  error?: string;
  fullPath: string;
  query?: string;
}

export const UploadFileCell: React.FC<UploadFileCellProps> = ({
  copyAriaLabel,
  copyTooltip,
  details,
  displayName,
  displayedPath,
  error,
  fullPath,
  query,
}) => (
  <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
    <Stack spacing={0.5} sx={{ minWidth: 0, width: '100%' }}>
      <Tooltip title={displayName} placement="bottom" arrow>
        <Typography variant="body2" sx={{ fontWeight: 600 }} noWrap>
          <HighlightedText value={displayName} query={query} />
        </Typography>
      </Tooltip>
      <Box sx={{ maxWidth: 360 }} title={fullPath}>
        <CopyableText
          variant="caption"
          color="text.secondary"
          textForCopy={fullPath}
          tooltipText={copyTooltip}
          copyWithButton="right"
          copyButtonProps={{
            size: 'small',
            edge: 'end',
            'aria-label': copyAriaLabel,
          }}
          copyIconProps={{ fontSize: 'small' }}
          parentGridProps={{ sx: { maxWidth: '100%' } }}
        >
          <HighlightedText value={displayedPath} query={query} />
        </CopyableText>
      </Box>
      {details}
      {error ? (
        <Typography variant="caption" color="error.main">
          {error}
        </Typography>
      ) : null}
    </Stack>
  </Box>
);
